module.exports = __webpack_public_path__ + "static/media/vimeo (2).e100be78.png";